import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  contractorInvoicesSelector,
  getCurrentContractor,
} from 'selectors/admin/contractors/contractors';
import PaginationTable from 'components/shared/pagination/table/PaginationTable';
import { getContractorInvoices } from 'actions/admin/contractors/contractors';
import { toUpperFirstLetter } from 'services/utils/text-util';
import Date from 'components/shared/text/Date';
import Number from 'components/shared/text/Number';
import DocumentLink from 'components/shared/document/DocumentLink';
import SimpleTable from 'components/shared/table/SimpleTable';

class ContractorDetailsInvoices extends Component {
  static propTypes = {
    contractorInvoices: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    currentContractor: PropTypes.shape({}),
    onContractorInvoicesGet: PropTypes.func.isRequired,
  };

  static defaultProps = {
    currentContractor: null,
  };

  componentDidMount() {
    const { currentContractor, onContractorInvoicesGet } = this.props;
    if (currentContractor !== null) {
      onContractorInvoicesGet(currentContractor.id);
    }
  }

  handlePageChange = (page) => {
    const { currentContractor, onContractorInvoicesGet } = this.props;
    onContractorInvoicesGet(currentContractor.id, page);
  };

  mapInvoices = (invoices) => {
    return invoices.map((invoice) => {
      return [
        <span className="small-bold">{invoice.work_order_number}</span>,
        toUpperFirstLetter(invoice.status),
        <Date value={invoice.due_date} format="LL" />,
        <Number value={invoice.cost} format="$0,0" />,
        <DocumentLink showIcon={false} url={invoice.document.document.url} />,
      ];
    });
  };

  render() {
    const { contractorInvoices } = this.props;
    return (
      <div className="contractor-details-invoices">
        <PaginationTable onCurrentPageChange={this.handlePageChange}>
          <SimpleTable
            headers={['WO #', 'STATUS', 'DUE DATE', 'AMOUNT', 'DOC LINK']}
            rows={this.mapInvoices(contractorInvoices)}
            emptyMessage="No Invoices"
          />
        </PaginationTable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contractorInvoices: contractorInvoicesSelector(state),
    currentContractor: getCurrentContractor(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onContractorInvoicesGet: (contractorId, page) => {
    dispatch(getContractorInvoices(contractorId, page));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractorDetailsInvoices);



// WEBPACK FOOTER //
// ./src/components/admin/contractors/ContractorDetailsInvoices.js